import MainSceneSetup from './scenes/MainSceneSetup';
import UIHandlers from './controls/UIHandlers';
import './style.css';
import { loadGoogleMapsScript, initializeAddressAutocomplete } from './helpers/addressAutocomplete';
import WizardManager from './helpers/wizard/wizard-manager';
import './helpers/wizard/wizard-styles.css'

// Define API endpoint constant
const API_ENDPOINT = 'https://gnogztrnq1.execute-api.ap-southeast-2.amazonaws.com/dev';

// DOM fully loaded
document.addEventListener('DOMContentLoaded', async () => {
    const loadingSpinner = document.getElementById('loading-spinner');
    const UIContainer = document.getElementById('ui-container');
    const loadingForm = document.getElementById('form-overlay');
    

    console.log('Starting initialization');
    
    // Helper functions
    function showAccessForm() {
        const overlay = document.getElementById('form-overlay');
        if (overlay) {
            overlay.style.display = 'flex';
        }
    }

    function hideAccessForm() {
        const overlay = document.getElementById('form-overlay');
        if (overlay) {
            overlay.style.display = 'none';
        }
    }

    function showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'notification-error';
        errorDiv.textContent = message;
        document.body.appendChild(errorDiv);
        setTimeout(() => errorDiv.remove(), 5000);
    }

    function showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'notification-success';
        successDiv.textContent = message;
        document.body.appendChild(successDiv);
        setTimeout(() => successDiv.remove(), 3000);
    }

   // Track the currently open section
    let currentOpenSection = null;

    // Helper function to close a section
    function closeSection(sectionId) {
        const content = document.getElementById(sectionId);
        const chevron = document.getElementById(`${sectionId}-chevron`);
        if (content) {
            content.classList.remove('visible');
        }
        if (chevron) {
            chevron.style.transform = '';
        }
    }

    // Helper function to open a section
    function openSection(sectionId) {
        const content = document.getElementById(sectionId);
        const chevron = document.getElementById(`${sectionId}-chevron`);
        if (content) {
            content.classList.add('visible');
        }
        if (chevron) {
            chevron.style.transform = 'rotate(180deg)';
        }
    }

    // Main toggle functions
    window.toggleStairType = function() {
        const sectionId = 'stair-type-container';
        const content = document.getElementById(sectionId);
        
        // If this section is already open, just close it
        if (content.classList.contains('visible')) {
            closeSection(sectionId);
            currentOpenSection = null;
            return;
        }
        
        // Close currently open section if any
        if (currentOpenSection) {
            if (currentOpenSection === 'address-update-form') {
                document.getElementById(currentOpenSection).classList.add('hidden');
                document.getElementById('address-chevron').classList.remove('collapsed');
            } else {
                closeSection(currentOpenSection);
            }
        }
        
        // Open this section
        openSection(sectionId);
        currentOpenSection = sectionId;
    };

    window.toggleStairSpecs = function() {
        const sectionId = 'stair-specs-container';
        const content = document.getElementById(sectionId);
        
        // If this section is already open, just close it
        if (content.classList.contains('visible')) {
            closeSection(sectionId);
            currentOpenSection = null;
            return;
        }
        
        // Close currently open section if any
        if (currentOpenSection) {
            if (currentOpenSection === 'address-update-form') {
                document.getElementById(currentOpenSection).classList.add('hidden');
                document.getElementById('address-chevron').classList.remove('collapsed');
            } else {
                closeSection(currentOpenSection);
            }
        }
        
        // Open this section
        openSection(sectionId);
        currentOpenSection = sectionId;
    };

    window.toggleAddressUpdate = function() {
        const sectionId = 'address-update-form';
        const form = document.getElementById(sectionId);
        const chevron = document.getElementById('address-chevron');
        
        // If this section is already open, just close it
        if (!form.classList.contains('hidden')) {
            form.classList.add('hidden');
            chevron.classList.remove('collapsed');
            currentOpenSection = null;
            return;
        }
        
        // Close currently open section if any
        if (currentOpenSection) {
            if (currentOpenSection === 'address-update-form') {
                document.getElementById(currentOpenSection).classList.add('hidden');
                document.getElementById('address-chevron').classList.remove('collapsed');
            } else {
                closeSection(currentOpenSection);
            }
        }
        
        // Open this section
        form.classList.remove('hidden');
        chevron.classList.add('collapsed');
        currentOpenSection = sectionId;
    };
    function handleAddressSection(show) {
        const section = document.getElementById('update-address-section');
        if (section) {
            if (show) {
                section.classList.remove('hidden');
                setupAddressFields();
            } else {
                section.classList.add('hidden');
            }
        }
    }
    // Setup Google Maps autocomplete for address fields
    async function setupAddressFields() {
        try {
            await loadGoogleMapsScript();
            
            // Initialize autocomplete for both address fields
            initializeAddressAutocomplete();
            
            const newAddressInput = document.getElementById('new-site-address');
            if (newAddressInput && window.google) {
                const autocomplete = new google.maps.places.Autocomplete(newAddressInput, {
                    types: ['address'],
                    componentRestrictions: { country: 'nz' }
                });

                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place.formatted_address) {
                        newAddressInput.value = place.formatted_address;
                    }
                });
            }
        } catch (error) {
            console.error('Error setting up address fields:', error);
        }
    }

    // Session management
    async function checkUserSession() {
        const userEmail = localStorage.getItem('userEmail');
        console.log('Checking session for email:', userEmail);
        
        if (!userEmail) {
            console.log('No email found in localStorage, showing access form');
            showAccessForm();
            handleAddressSection(false);
            
            // Hide submit button and keep price blurred for new users
            document.getElementById('submitQuoteBtn').classList.add('hidden');
            document.getElementById('price').classList.add('price-blur');
            document.getElementById('price-overlay').style.display = '';
            
            return;
        }
    
        try {
            console.log('Fetching user info from:', `${API_ENDPOINT}/get-user-info`);
            
            const response = await fetch(`${API_ENDPOINT}/get-user-info?email=${encodeURIComponent(userEmail)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });
    
            console.log('Response status:', response.status);
    
            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                
                if (response.status === 401 || response.status === 404) {
                    console.log('Session expired, clearing localStorage');
                    localStorage.removeItem('userEmail');
                    showAccessForm();
                    handleAddressSection(false);
                    
                    // Hide submit button and keep price blurred if session expired
                    document.getElementById('submitQuoteBtn').classList.add('hidden');
                    document.getElementById('price').classList.add('price-blur');
                    document.getElementById('price-overlay').style.display = '';
                    
                    return;
                }
                throw new Error(`Server response: ${response.status} ${errorText}`);
            }
    
            const userData = await response.json();
            console.log('User data retrieved:', userData);
            window.userInfo = userData;
            hideAccessForm();
            handleAddressSection(true); // Show address section for returning users
            
            // Show submit button and reveal price for authenticated users
            document.getElementById('submitQuoteBtn').classList.remove('hidden');
            document.getElementById('price').classList.remove('price-blur');
            document.getElementById('price-overlay').style.display = 'none';
            
        } catch (error) {
            console.error('Error checking user session:', error);
            showAccessForm();
            handleAddressSection(false);
            showError('Unable to retrieve user session. Please sign in again.');
            
            // Hide submit button and keep price blurred on error
            document.getElementById('submitQuoteBtn').classList.add('hidden');
            document.getElementById('price').classList.add('price-blur');
            document.getElementById('price-overlay').style.display = '';
        }
    }

    // Initialize stylesheet loading
    await Promise.all(
        Array.from(document.styleSheets).map(styleSheet => {
            if (styleSheet.href) {
                return new Promise((resolve) => {
                    const link = document.querySelector(`link[href="${styleSheet.href}"]`);
                    if (link.sheet) {
                        resolve();
                    } else {
                        link.onload = resolve;
                    }
                });
            }
            return Promise.resolve();
        })
    );

    // Initialize scene setup
    const sceneSetup = new MainSceneSetup();
    sceneSetup.uiHandlers = new UIHandlers(sceneSetup);
    sceneSetup.uiHandlers.init();
    sceneSetup.animate();
    const wizard = new WizardManager();
    wizard.initialize();

    // Set up form submission handler
    /**
        const accessForm = document.getElementById('access-form');
        if (accessForm) {
            accessForm.addEventListener('submit', async (event) => {
                event.preventDefault();
                
                const formData = {
                    name: document.getElementById('name').value,
                    email: document.getElementById('email').value,
                    phone: document.getElementById('phone').value,
                    siteAddress: document.getElementById('siteAddress').value
                };
    
                try {
                    console.log('Submitting form data:', formData);
                    const response = await fetch(`${API_ENDPOINT}/submit-form`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData),
                        credentials: 'include'
                    });
    
                    if (!response.ok) {
                        const errorText = await response.text();
                        throw new Error(`Server response: ${response.status} ${errorText}`);
                    }
    
                    console.log('Form submission successful');
                    localStorage.setItem('userEmail', formData.email);
                    window.userInfo = formData;
                    hideAccessForm();
                    handleAddressSection(true);
                    showSuccess('Access granted successfully!');
    
                } catch (error) {
                    console.error('Error submitting form:', error);
                    showError('Failed to submit form. Please try again.');
                }
            });
        }
    */

    // Set up address update handler
    const updateAddressBtn = document.getElementById('update-address-btn');
    if (updateAddressBtn) {
        updateAddressBtn.addEventListener('click', async () => {
            const newAddress = document.getElementById('new-site-address').value;
            if (!newAddress || !window.userInfo) return;

            try {
                const formData = {
                    ...window.userInfo,
                    siteAddress: newAddress
                };

                const response = await fetch(`${API_ENDPOINT}/submit-form`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData),
                    credentials: 'include'
                });

                if (!response.ok) {
                    throw new Error('Failed to update address');
                }

                // Update local user info
                window.userInfo.siteAddress = newAddress;
                
                showSuccess('Address updated successfully!');

                // Clear and hide the form
                document.getElementById('new-site-address').value = '';
                document.getElementById('address-update-form').classList.add('hidden');
                document.getElementById('address-chevron').classList.remove('collapsed');

            } catch (error) {
                console.error('Error updating address:', error);
                showError('Failed to update address. Please try again.');
            }
        });
    }

    // Set up quote submission handler
    const submitQuoteBtn = document.getElementById('submitQuoteBtn');
    if (submitQuoteBtn) {
        submitQuoteBtn.addEventListener('click', async () => {
            if (!window.userInfo) {
                console.log('No user info found, showing access form');
                showAccessForm();
                return;
            }
            // Your existing quote submission logic here
        });
    }

    // Initialize Google Maps
    try {        
            // Load Maps first
            console.log('Starting Google Maps load');
            await loadGoogleMapsScript();
            initializeAddressAutocomplete();
            await checkUserSession();
            
           // Show controls and hide spinner
            if (loadingSpinner) {
                loadingSpinner.classList.add('hidden');
            }
            if (UIContainer) {
                UIContainer.classList.remove('hidden');
            }
            if (loadingForm) {
                loadingForm.classList.remove('hidden');
            }
            
        } catch (error) {
            console.error('Error during initialization:', error);
            // Show controls even on error, hide spinner
            loadingSpinner.classList.add('hidden');
            UIContainer.classList.remove('hidden');
            loadingForm.classList.remove('hidden');
        }
        // Hide the form overlay initially
        document.getElementById('form-overlay').classList.add('hidden');

        // Add view price button event listener
        document.getElementById('viewPriceBtn').addEventListener('click', function() {
        // Show the form overlay
        document.getElementById('form-overlay').classList.remove('hidden');
        });

        // Function to check if we should reveal the price
        function checkPriceReveal() {
        const userEmail = localStorage.getItem('userEmail');
        
        if (userEmail) {
            // User is properly authenticated
            document.getElementById('price').classList.remove('price-blur');
            document.getElementById('price-overlay').style.display = 'none';
        }
        }

        // Check if price should be revealed
        checkPriceReveal();
});